(() => {
  const idOf = (value) => String(value ?? '').replace(/^gid:\/\/shopify\/Product\//, '');

  function recommend({ config, sourceProducts = [], excludedIds = [], catalog = [], mode = 'cart', limitOverride = null }) {
    if (!config?.products) return [];
    const cat = catalog instanceof Map
      ? new Map([...catalog].map(([key, product]) => [idOf(product.id ?? key), product]))
      : new Map(catalog.map((product) => [idOf(product.id), product]));
    const sources = [...new Set(sourceProducts.map((product) => idOf(product.id)).filter(Boolean))];
    const excluded = new Set([...sources, ...excludedIds.map(idOf)]);
    for (const id of [...sources, ...excludedIds.map(idOf)]) {
      for (const component of config.boxComponents?.[id] || []) excluded.add(idOf(component));
    }
    const limit = limitOverride ?? (mode === 'pdp' ? 8 : 4);
    const eligible = (id) => !excluded.has(id) && cat.get(id)?.available && !cat.get(id)?.requiresSellingPlan;
    const candidate = (id, score, extra = {}) => ({ id, product: cat.get(id), score, family: config.products[id]?.family, ...extra });

    if (mode === 'pdp') {
      const source = config.products[sources[0]];
      if (!source) return [];
      const seen = new Set();
      const result = [];
      for (const row of [...(source.pdp || []), ...(source.cartRules || [])]) {
        const id = idOf(row.id);
        if (seen.has(id)) continue;
        seen.add(id);
        if (eligible(id)) result.push(candidate(id, row.score));
      }
      return result.slice(0, limit);
    }

    const scores = new Map();
    for (const source of sources) {
      for (const row of config.products[source]?.cartRules || []) {
        const id = idOf(row.id);
        if (!eligible(id)) continue;
        const current = scores.get(id) || { score: 0, coOrders: 0, coverage: 0 };
        current.score += Number(row.score) || 0;
        current.coOrders += Number(row.coOrders) || 0;
        current.coverage += 1;
        scores.set(id, current);
      }
    }
    return [...scores].map(([id, value]) => candidate(id, value.score, value))
      .sort((a, b) => b.score - a.score || b.coOrders - a.coOrders || b.coverage - a.coverage || a.id.localeCompare(b.id))
      .slice(0, limit);
  }

  async function loadCards({ candidates, limit, cardSection }) {
    const selected = [];
    let offset = 0;
    while (selected.length < limit && offset < candidates.length) {
      const batch = candidates.slice(offset, offset + limit - selected.length);
      offset += batch.length;
      const results = await Promise.all(batch.map(async (candidate) => {
        try {
          const url = new URL(candidate.product.url, window.location.origin);
          url.searchParams.set('section_id', cardSection);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return null;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const card = html.querySelector('[data-cart-cross-sell-card]');
          if (!card || card.dataset.productId !== candidate.id || card.dataset.available !== 'true' || card.dataset.requiresSellingPlan === 'true') return null;
          return { candidate, card };
        } catch (_) {
          return null;
        }
      }));
      selected.push(...results.filter(Boolean));
    }
    return selected;
  }

  window.PerroneCrossSellEngine = { normalizeId: idOf, recommend, loadCards };
})();
